var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","small":"","width":"38px","height":"38px"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"size":"20","color":"white"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }